import { render, staticRenderFns } from "./MaintainInfo.vue?vue&type=template&id=12c0b9d6"
import script from "./MaintainInfo.vue?vue&type=script&lang=js"
export * from "./MaintainInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports